import { ODataModel } from '../../interfaces/odata-model.interface';
import { TableModelOptions } from '../options/table-model-options';

export class TableModel<T extends ODataModel> {
    public selectedRow: T;
    public constructor(
        public rows: T[] = [],
        public options: TableModelOptions,
    ) {
        if (this.options.initialSelectRow) {
            this.selectedRow = rows[this.options.initialSelectRow];
        }
    }

    public selectByIndex(index: number): boolean {
        if (index < 0 || index >= this.rows.length) {
            return false;
        }

        this.selectedRow = this.rows[index];

        return true;
    }
}
